import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const NotificationConfigFormGeneral = ({
  notification_config,
  errors,
  handleValueChange,
  isSubmitted,
  t,
  values,
}) => {
  return (
    <Form.Section title={t('notification_config.form.general')}>
      <div className="row align-items-center">
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('notification_config.fields.name')}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.Checkbox
            name="send_email"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.send_email}
            label={t('notification_config.fields.send_mail', { context: 'female' })}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.Checkbox
            name="active"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.active}
            label={t('common.active', { context: 'female' })}
          />
        </div>
        {/* <div className="col-12">
          <Form.FieldTextArea
            error={(isSubmitted && errors.description) || {}}
            name={"description"}
            label={t("notification_config.fields.description")}
            handleChange={handleValueChange}
            t={t}
            value={values.description}
          />
        </div> */}
      </div>
    </Form.Section>
  );
};

export default translate()(NotificationConfigFormGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/sections/NotificationConfigFormGeneral.js